import { rando } from '../../../lib/rando-sidecar'
import { voyageMessageCrewCarry } from '../multi/voyageMessageCrewCarry-sidecar'
import { EEffectCommand } from '../multi/voyageMessageEffectCommand'
import { voyageMessageEffectCommand } from '../multi/voyageMessageEffectCommand-sidecar'
import { EVoyageCarryableType } from '../voyageCarryableData'
import { voyageTilemap } from '../voyageTilemap-sidecar'

export function run_bomb(min: number, max: number) {
  let num = rando.i(min, max)
  for (let i = 0; i < num; i++) {
    setTimeout(() => {
      let fl = voyageTilemap.getRandomFloor()

      let type = rando.sample([
        EVoyageCarryableType.Breachbomb,
        EVoyageCarryableType.Firebomb,
      ])

      voyageMessageCrewCarry.sendCreateMessageAndImmediatelyExecute({
        i: fl.i,
        j: fl.j,
        type: type,
      })

      voyageMessageEffectCommand.sendMessageAndImmediatelyExecute({
        command: EEffectCommand.HitParticles,
        x: fl.x,
        y: fl.y,
      })
    }, 1000 * i)

    // let entrance = voyageTilemap.getRandomLanding()
    // voyageCrew.moveToIJ()
  }
}
